import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import ModalRoot from 'components/Modal/ModalRoot';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';

import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
  tableShadow: {
    boxShadow:
      '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
    borderRadius: '4px',
  },
  formControlSelect: {
    width: '100%',
    marginTop: theme.spacing(),
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
  card: {
    width: 'auto',
    margin: '10px',
    display: 'inline-block',
  },
});

class PlayerProfiles extends React.Component {
  state = { searchByName: '', hasCooldon: false };

  updateSearch = event => {
    const target = event.target;
    let hasCooldon = this.state.hasCooldon;
    this.setState({ searchByName: target.value });

    if (!hasCooldon) {
      hasCooldon = true;
      setTimeout(() => {
        hasCooldon = false;
        this.setState({ hasCooldon: hasCooldon });

        this.props.refreshPlayers(this.props.selectedTeam, target.value);
      }, 1000);
      this.setState({ hasCooldon: hasCooldon });
    }
  };

  renderSelect(list, disabled, value, title) {
    const { classes, changeTeam, sort } = this.props;

    return (
      <FormControl className={classes.formControlSelect}>
        <InputLabel id="demo-simple-select-label">{title}</InputLabel>
        <Select
          id="demo-simple-select"
          disabled={disabled}
          value={value}
          onChange={event => {
            changeTeam(event.target.value, this.state.searchByName, sort);
          }}
        >
          <MenuItem value={null} className="select">
            <div className="select">
              <em>Doesn't Have a team</em>
            </div>
          </MenuItem>
          {list.map(row => (
            <MenuItem key={row._id} value={row._id}>
              <div className="select">{row.name}</div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  renderTableCell(label, field) {
    const { sort, sortTable } = this.props;

    return (
      <TableCell>
        <TableSortLabel
          active={sort.field === field}
          direction={sort.direction}
          onClick={() =>
            sortTable(
              {
                field,
                direction:
                  sort.direction === 'desc' || field !== sort.field ? 'asc' : 'desc',
              },
              this.state.searchByName
            )
          }
        >
          {label}
        </TableSortLabel>
      </TableCell>
    );
  }

  render() {
    const {
      players,
      teams,
      selectedTeam,
      classes,
      count,
      page,
      pageSize,
      onChangePage,
      onChangeRowsPerPage,
    } = this.props;

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'inline-flex', width: '300px' }}>
            {this.renderSelect(teams, false, selectedTeam ? selectedTeam : '', 'Team')}
          </div>
        </div>
        <div className={classes.tableShadow} style={{ marginTop: '20px' }}>
          <div
            style={{
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'space-between',
              padding: '24px 8px 0px 24px',
            }}
          >
            <div style={{ display: 'flex' }}>
              <Typography variant="h6" gutterBottom>
                Players
              </Typography>
            </div>
            <div>
              <div>
                <TextField
                  placeholder="Search by Name"
                  inputProps={{ 'aria-label': 'Search by Name' }}
                  onChange={this.updateSearch}
                  value={this.state.searchByName}
                />
                <IconButton disabled aria-label="search">
                  <SearchIcon />
                </IconButton>
              </div>
            </div>
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <TableSortLabel>{'Photo'}</TableSortLabel>
                </TableCell>
                {this.renderTableCell('First Name', 'firstName')}
                {this.renderTableCell('Last Name', 'lastName')}
                <TableCell>Options</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {players.map(row => (
                <TableRow key={row._id} hover>
                  <TableCell>
                    <Card className={classes.card}>
                      <CardMedia
                        style={{
                          backgroundImage: `url(${row.photo}) `,
                          backgroundSize: 'contain',
                          padding: '20px',
                          border: '1px solid rgba(255, 255, 255, 1)',
                          width: '100px',
                          height: '100px',
                        }}
                        image={`url('${row.photo}')`}
                      />
                    </Card>
                  </TableCell>
                  <TableCell>{row.firstName}</TableCell>
                  <TableCell>{row.lastName}</TableCell>
                  <TableCell>{'options'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            component="div"
            count={count}
            rowsPerPage={pageSize}
            page={page}
            onPageChange={onChangePage}
            onRowsPerPageChange={onChangeRowsPerPage}
          />
        </div>

        <ModalRoot />
      </div>
    );
  }
}

export default withStyles(styles)(PlayerProfiles);
